import {reportingSvg as Icon__small__reportingSvg} from '../Icon__small/Icon__small--reporting.js';

export var reporting = {
  name: 'reporting',
  category: 'icon',
  colorable: true,
  svg: Icon__small__reportingSvg,
};
